<template>
  <div class="AboutUs">
    <!-- 关于我们 -->
    <div class="cpzx_bj">
      <img src="@/assets/img/spzx_xqy/banner-bg.png" alt="" />
      <ul class="cpzx_bj_text">
        <li>关于我们</li>
        <li>不断提升自身技术及用户体验</li>
        <li></li>
      </ul>
    </div>
    <div class="AboutUs_box">
      <div class="contentBox">
        <div class="toggleBar">
          <div class="toggleBar_box">
            <button
              class="toggleBar_box_btn"
              v-for="(item, index) in buttonArr"
              :key="index"
               @click="navigateTo(index)"
              :class="[currentIndex === index ? 'btnStyleChange' : '']"
            >
              <span>{{ item }}</span>
              <img
                v-show="currentIndex === index"
                src="@/assets/img/aboutUs/gywm_xl.png"
                alt=""
              />
            </button>
          </div>
        </div>

        <div class="contentBody">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AboutUs',
  data () {
    return {
      buttonArr: ['公司简介', '荣誉介绍', '企业文化'],
      currentIndex: 0,
      routeMap: {
        0: '/aboutUs/companyProfile',
        1: '/aboutUs/honoraryIntroduction',
        2: '/aboutUs/enterpriseCulture'
      },
      pathToIndex: {
        '/aboutUs/companyProfile': 0,
        '/aboutUs/honoraryIntroduction': 1,
        '/aboutUs/enterpriseCulture': 2
      }
    }
  },
  methods: {
    navigateTo (index) {
      this.currentIndex = index
      localStorage.setItem('activeMenuIndex', index)
      this.$router.push(this.routeMap[index])
    },
    setCurrentIndexByRoute () {
      const currentPath = this.$route.path
      if (this.pathToIndex.hasOwnProperty(currentPath)) {
        this.currentIndex = this.pathToIndex[currentPath]
        localStorage.setItem('activeMenuIndex', this.currentIndex)
      }
    }
  },
  watch: {
    '$route' (to, from) {
      this.setCurrentIndexByRoute()
    }
  },
  mounted () {
    this.setCurrentIndexByRoute()

    if (this.currentIndex === 0 && this.$route.path !== '/aboutUs/companyProfile') {
      const savedIndex = localStorage.getItem('activeMenuIndex')
      if (savedIndex !== null) {
        const index = parseInt(savedIndex)
        if (index >= 0 && index < this.buttonArr.length) {
          this.navigateTo(index)
        }
      }
    }

    // 页面加载后自动滚动到合适位置
    // this.$nextTick(() => {
    //   // AboutUs页面滚动到toggleBar位置，让用户能看到导航按钮
    //   const toggleBar = document.querySelector('.toggleBar')
    //   if (toggleBar) {
    //     const bannerHeight = 274 // banner的固定高度
    //     const offsetTop = bannerHeight + 50 // 在banner下方留一点空间
    //
    //     window.scrollTo({
    //       top: offsetTop,
    //       behavior: 'smooth'
    //     })
    //   }
    // })
  }
}
</script>

<style scoped lang="scss">
.AboutUs {
  width: 100%;
  .cpzx_bj {
    width: 100%;
    height: 274px;
    position: relative;
    img {
      width: 100%;
      height: 274px;
    }
    .cpzx_bj_text {
      width: 310px;
      height: 134px;
      position: absolute;
      top: 100px;
      left: 50%;
      margin-left: -155px;
      li {
        color: #fff;
        &:nth-child(1) {
          width: 100%;
          height: 56px;
          font-size: 30px;
          padding-left: 68px;
        }

        &:nth-child(2) {
          width: 100%;
          height: 24px;
          font-size: 18px;
        }
        &:nth-child(3) {
          width: 220px;
          height: 4px;
          background-color: #fff;
          margin-top: 22px;
          margin-left: 16px;
          position: relative;
          &:after {
            content: "";
            width: 60px;
            height: 10px;
            background-color: #fff;
            position: absolute;
            top: -3px;
            left: 80px;
          }
        }
      }
    }
  }
  .AboutUs_box {
    width: 100%;
    padding: 0 0 36px 0;
    display: flex;
    // justify-content: center;
    .contentBox {
      //   width: 1206px;
      width: 100%;
      //   height: 180px;

      .toggleBar {
        width: 100%;
        height: 52px;
        padding: 0 40px;
        display: flex;
        justify-content: center;
        // margin-top: 30px;
        // border: 1px solid red;
        position: absolute;
        top: 410px;
        left: 0;
        .toggleBar_box {
          width: 814px;
          height: 52px;
          display: flex;
          justify-content: space-between;

          .toggleBar_box_btn {
            border-color: transparent;
            background-color: #ffffff;
            color: #999999;
            font-size: 18px;
            font-weight: 400;
          }
          .btnStyleChange {
            background-color: #2b8737;
            color: #fff;
            border-color: transparent;
          }

          button {
            width: 200px;
            height: 52px;
            background-color: #efefef;
            border-color: transparent;
            position: relative;

            &:hover {
              cursor: pointer;
              opacity: 0.7;
            }
            span {
              font-size: 16px;
            }
            .btnStyleChange {
              padding-right: 20px !important;
            }
            img {
              width: 24px;
              height: 13px;
              position: absolute;
              top: 17px;
              left: 134px;
            }
          }
        }
      }

      .contentBody {
        width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/aboutUs/AboutUs.vue